import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.hasMenuTarget) {
      const isHidden = this.menuTarget.classList.contains('hidden')

      if (isHidden) {
        this.show()
      } else {
        this.hide()
      }
    }
  }

  show() {
    this.menuTarget.classList.remove('hidden')
    setTimeout(() => {
      document.addEventListener('click', this.boundHandleClickOutside)
    }, 10)
  }

  hide() {
    this.menuTarget.classList.add('hidden')
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside)
  }
}
